import { combineReducers } from "redux";
import checkTimePageReducer from "./checkTimePageReducer";
import calendarReducer from "./calendarReducer";
import usersReducer from "./usersReducer";
import shiftPageReducer from "./shiftPageReducer";
import loginPageReducer from "./loginReducer";
import basicProfileReducer from "./basicProfileReducer";
import userHistoryTimelineReducer from "./userHistoryTimelineReducer";
import userShiftTypeReducer from "./userShiftTypeReducer";
import statusReducer from "../reducer/statusReducer";
import branchReducer from "../reducer/branchReducer";
import settingPageReducer from "./settingPageReducer";
import userFaceReducer from "./userFaceReducer";
import analysisReducer from "./analysisReducer";
import appRootReducer from "./appReducer";
import jobTypeReducer from "./jobTypeReducer";
import leaveTypeReducer from "./leaveTypeReducer";
import leaveHistoryReducer from "./leaveHistoryReducer";
import salaryReducer from "./salaryReducer";
import dailyReportReducer from "./dailyReportReducer";
import payrollReducer from "./payroll";
import notificationReducer from "./notificationReducer";
import Quota from "./quota";
import GeneralSettingReducer from "./generalSetting";
import qrCodeReducer from "./qrCodeReducer";
import { formCreateReasonReducer } from "./statisticReducer/formCreateReasonReducer";
import { popupDeleteReasonReducer } from "./statisticReducer/popupDeleteReasonReducer";
import dailyRatingReducer from "./dailyRatingReducer";
import { errorsHandlerReducer } from "./errorsHandlerReducer";
import { initialServiceReducer } from "./initialServiceReducer";
import { metaDataReducer } from "./metaDataReducer";
import metaDataOrgReducer from "./metaDataOrgReducer";

const appReducer = combineReducers({
  checkTimePageReducer,
  calendarReducer,
  usersReducer,
  shiftPageReducer,
  loginPageReducer,
  basicProfileReducer,
  userHistoryTimelineReducer,
  userShiftTypeReducer,
  statusReducer,
  branchReducer,
  settingPageReducer,
  userFaceReducer,
  analysisReducer,
  appRootReducer,
  jobTypeReducer,
  leaveTypeReducer,
  leaveHistoryReducer,
  salaryReducer,
  dailyReportReducer,
  payrollReducer,
  notificationReducer,
  Quota,
  GeneralSettingReducer,
  formCreateReasonReducer,
  popupDeleteReasonReducer,
  qrCodeReducer,
  dailyRatingReducer,
  errorsHandlerReducer,
  initialServiceReducer,
  metaDataReducer,
  metaDataOrgReducer,
});

const rootReducer = (state, action) => {
  return appReducer(state, action);
};

export default rootReducer;
